import React from "react";

const FundementalGraphs = () => {
  return <div>FundementalGraphs</div>;
};

export default FundementalGraphs;
